import { configInputConverter } from '@seu-converter';
import {
  SeuApiConverter,
  SeuComponent,
  SeuComponentApi,
  SeuComponentBase,
  SeuComponentBaseApi,
} from '@seu-types';
import {
  inputHandlesConverter,
  outputHandlesConverter,
} from './handle.converter';

export const componentConverter: SeuApiConverter<
  SeuComponent,
  SeuComponentApi
> = {
  fromApi: (input) => {
    return {
      ...input,
      id: String(input.id),
      inputs: input.inputs.map((configInput) => {
        return configInputConverter.fromApi(configInput);
      }),
      outputHandles: outputHandlesConverter.fromApi(input.outputHandles ?? []),
      inputHandles: inputHandlesConverter.fromApi(input.inputHandles ?? []),
    };
  },
  toApi: (input) => {
    return {
      ...input,
      id: Number(input.id),
      inputs: input.inputs.map((configInput) => {
        return configInputConverter.toApi(configInput);
      }),
      outputHandles: outputHandlesConverter.toApi(input.outputHandles ?? []),
      inputHandles: inputHandlesConverter.toApi(input.inputHandles ?? []),
    };
  },
};

export const componentBaseConverter: SeuApiConverter<
  SeuComponentBase,
  SeuComponentBaseApi
> = {
  fromApi: (input) => {
    return {
      ...input,
      inputs: input.inputs.map((configInput) => {
        return configInputConverter.fromApi(configInput);
      }),
      outputHandles: outputHandlesConverter.fromApi(input.outputHandles ?? []),
      inputHandles: inputHandlesConverter.fromApi(input.inputHandles ?? []),
    };
  },
  toApi: (input) => {
    return {
      ...input,
      inputs: input.inputs.map((configInput) => {
        return configInputConverter.toApi(configInput);
      }),
      outputHandles: outputHandlesConverter.toApi(input.outputHandles ?? []),
      inputHandles: inputHandlesConverter.toApi(input.inputHandles ?? []),
    };
  },
};
